import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TranslateModule } from '@ngx-translate/core';
import { IimCardModule } from '@iim-angular/components';
import { PlatformModule } from '@lib/core';
import { WidgetsOverviewComponent } from './widgets-overview/widgets-overview.component';
import { AddWidgetDialogComponent } from './add-widget-dialog/add-widget-dialog.component';
import { ExpandWidgetDialogComponent } from './expand-widget-dialog/expand-widget-dialog.component';

@NgModule({
    imports: [CommonModule, TranslateModule, DragDropModule, PlatformModule, IimCardModule],
    declarations: [WidgetsOverviewComponent, AddWidgetDialogComponent, ExpandWidgetDialogComponent],
    exports: [WidgetsOverviewComponent, AddWidgetDialogComponent, ExpandWidgetDialogComponent],
})
export class WidgetsOverviewUiModule {}
